import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { EuiButton, EuiFormRow, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiTextArea } from '@elastic/eui'

import { useDisapproveCampaignMutation } from 'api/rtkQueryApi/platform/campaignsApi'
import { showErrorToast, showSuccessToast } from 'app/appSlice'

interface DisapproveCampaignModalProps {
  accountId: string
  campaignId: string
  onClose: () => void
  onDisapproved?: () => void
}

export const DisapproveCampaignModal: React.FC<DisapproveCampaignModalProps> = ({ accountId, campaignId, onClose, onDisapproved }) => {
  const dispatch = useDispatch()
  const [reason, setReason] = useState('')
  const [disapproveCampaign, disapproveCampaignResult] = useDisapproveCampaignMutation()

  const onConfirm = async () => {
    try {
      await disapproveCampaign({ accountId, campaignId, reason }).unwrap()
      dispatch(showSuccessToast('Campaign disapproved'))
      onDisapproved?.()
      onClose()
    } catch {
      dispatch(showErrorToast('Failed to disapprove campaign'))
    }
  }

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Disapprove campaign</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiFormRow label='Reason (optional)' fullWidth>
          <EuiTextArea value={reason} onChange={e => setReason(e.target.value)} rows={3} fullWidth />
        </EuiFormRow>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButton onClick={onClose}>Cancel</EuiButton>
        <EuiButton color='danger' fill onClick={onConfirm} isLoading={disapproveCampaignResult.isLoading}>
          Disapprove
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  )
}
